import * as TK from 'components/post/MyPosts/translations/constants';
import { Translations } from 'translations/types';

export const myPostsEnUsLocale: Translations = {
  [TK.MY_POSTS_LOADING_MORE]: 'Loading more posts',
};
